export const insuranceInfoLogoItems = [
  {
    src: '/images/logo-united-health.svg',
    alt: 'United health insurance logo',
    width: 124,
  },
  {
    src: '/images/logo-humana.svg',
    alt: 'Humana insurance logo',
    width: 109,
  },
  {
    src: '/images/logo-bcbs.svg',
    alt: 'BCBS insurance logo',
    width: 143,
  },
  {
    src: '/images/logo-aetna.svg',
    alt: 'Aetna insurance logo',
    width: 101,
  },
  {
    src: '/images/logo-cigna.svg',
    alt: 'Cigna insurance logo',
    width: 119,
  },
  {
    src: '/images/logo-tufts.svg',
    alt: 'Tufts insurance logo',
    width: 103,
  },
  {
    src: '/images/logo-tricare.svg',
    alt: 'Tricare insurance logo',
    width: 83,
  },
  {
    src: '/images/logo-medicare.svg',
    alt: 'Medicare insurance logo',
    width: 164,
  },
]
